module.exports = __webpack_public_path__ + "img/slide11-piece-11.2af0f07c.png";